import { Customer, CompanyFeature } from '@graphql'

import { accountingErrors } from '@/constants/errors'

export const getAccountingErrorMessage = (
  error: accountingErrors,
  type?: string
) => {
  if (error === accountingErrors.NO_ACCOUNTS) {
    return `You cannot view your ${type?.toLowerCase().replace(/_/g, ' ')} until your account is linked with your grain provider account.`
  }
  if (error === accountingErrors.NO_ACCOUNTING_DATA) {
    return "Looks like you don't have any accounting data available. Please contact support if you have any questions."
  }
  return error
}

export const isInformationMissing = (
  feature: CompanyFeature,
  user: Customer | null
) => {
  if (
    (feature === CompanyFeature.Signatures ||
      feature === CompanyFeature.SignatureRequests ||
      feature === CompanyFeature.Offers) &&
    (!user?.email || !user?.fullName)
  ) {
    return true
  }
  if (
    [
      CompanyFeature.Contracts,
      CompanyFeature.ScaleTickets,
      CompanyFeature.OutboundScaleTickets,
      CompanyFeature.Settlements,
      CompanyFeature.Balances,
      CompanyFeature.Bookings
    ].indexOf(feature) > -1 &&
    !user?.mobilePhone
  ) {
    return true
  }
  return false
}

export const isTokenExpired = (
  expiration: number | null | undefined
): boolean => {
  if (!expiration) {
    return true
  }

  const bufferInSeconds = 10
  const currentTime = new Date()
  const expirationTime = new Date(expiration - bufferInSeconds * 1000)

  return expirationTime < currentTime
}
